import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const notificationApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/notification",
      params,
    }),
  totalUnread: (): AxiosPromise<any> =>
    request({
      url: "/v1/admin/notification/total/unread",
    }),
  handleReadNotification: (notificationId: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/notification/${notificationId}/read`,
      method: "post",
    }),
  handleReadAllNotification: (): AxiosPromise<any> =>
    request({
      url: `/v1/admin/notification/read/all`,
      method: "post",
    }),
};
